<template>
  <div>
    <v-dialog v-model="dialog" scrollable max-width="600px">
      <template v-slot:activator="{ on }">
        <span v-on="on" class="class" href="#muuda" style="cursor: pointer">
          <span v-t="'Edit'" />
        </span>
      </template>
      <v-card class="h-100">
        <dialog-card-header @close="dialog = false">
          <span v-t="'Update email'" />
        </dialog-card-header>
        <div class="d-flex justify-center">
          <div style="width: 400px">
            <v-alert type="warning">
              <span
                v-t="
                  'You\'re about to change the email you use to sign in. After changing the e-mail, you\'ll no longer be able to access the Bookus page with the previous e-mail.'
                "
              />
            </v-alert>
            <v-text-field
              v-if="form"
              v-model="form.email"
              :error-messages="form.error('email')"
              :error="form.state('email')"
              :label="$t('Enter new email')"
              name="new_email"
              required
              v-bind="$pr.textField"
            />

            <div class="d-flex justify-end">
              <v-btn class="mb-5 mr-2" @click="dialog = false">Katkesta</v-btn>
              <v-btn class="mb-5" color="success" @click="submit" :loading="loading">
                Salvesta
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Form from "@/landing/common/form";

export default {
  created() {
    const user = this.$store.state.user;
    this.form = new Form(
      { email: "" },
      {
        url: "api/update-email/" + user.id,
        method: "put",
      },
      this
    );
  },
  data() {
    return {
      mounted: false,
      dialog: false,
      form: null,
      loading: false,
      hasUpdatedName: false,
      disabled: false,
      successMessage: null,
      success: false,
    };
  },

  methods: {
    async submit() {
      //   if (this.loading) return;
      this.loading = true;
      try {
        const response = await this.form.submit();
        // this.$store.commit("SET", { user: response.data.item });
        // this.disabled = true;
        // setTimeout(() => {
        //   this.hasUpdatedName = false;
        //   this.disabled = false;
        // }, 5000);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
